import classNames from 'classnames'
import styles from './styles.module.scss'

type TitleProps = {
  classes?: string
  text: string
  type?: React.ElementType
}

function Title({ type: Component = 'h1', classes = '', text }: TitleProps) {
  return (
    <Component className={classNames(styles.title__wrapper, classes)}>
      {text}
    </Component>
  )
}

export default Title
